import DoneAllIcon from '@mui/icons-material/DoneAll';
import { useTheme } from '@mui/material';
import MuiCard from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Button from '~/client/components/base/button';
import { spc } from '~/client/components/base/spacer';
import Text from '~/client/components/base/text';

interface Props {
  className?: string;
}

const Card: React.FC<Props> = ({ className }) => {
  const theme = useTheme();
  const {
    text: { primary: primaryText, secondary: secondaryText },
    error: { main: errorText },
    warning: { main: warningText },
    success: { main: successText },
  } = theme.palette;
  return (
    <div className={className}>
      <MuiCard variant="outlined">
        <CardContent className="v2-content">
          <Text sz="title">Type</Text>
          <Text variant="h1">h1. Heading</Text>
          <Text variant="h2" color={secondaryText}>
            h2. Heading Light Grey
          </Text>
          <Text sz="title">TITLE</Text>
          <Text sz="title-small">TITLE SMALL</Text>
          <Text sz="body16" color={errorText}>
            Body 16. Error Text
          </Text>
          <Text sz="bold-body16">Bold Body 16</Text>
          <Text sz="body14" color={warningText}>
            Body 14. Warning Text
          </Text>
          <Text sz="bold-body14">Bold Body 14</Text>
          <Text sz="body12" color={successText}>
            Body 12. Success Text
          </Text>
          <Text sz="bold-body12">Bold Body 12</Text>
        </CardContent>
        <CardActions>
          <Button>Button</Button>
          <Button disabled>Disabled</Button>

          <Button tertiary outlined>
            Outlined
          </Button>
          <Button tertiary outlined disabled>
            Disabled
          </Button>

          <Button icon={DoneAllIcon} />
          <Button icon={DoneAllIcon} outlined />
          <Button icon={DoneAllIcon} disabled outlined />
        </CardActions>
      </MuiCard>
    </div>
  );
};

export default muiStyled(Card)(
  ({ theme }) => css`
    display: flex;

    .v2-content {
      /* Add spacings after all Text */
      > div {
        margin-bottom: ${theme.spacing(spc.xxs)};
      }
    }
  `
);
